<template>
  <el-dialog
    :title="`定时${type == 1 ? '开启' : '关闭'}`"
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    modal-append-to-body
    :modal="false"
    custom-class="open-clock-schedule-dialog"
    :close-on-click-modal="false"
    @closed="hide"
  >
    <el-form
      ref="form"
      :model="formData"
      label-width="80px"
    >
      <el-form-item label="开启日期">
        <el-date-picker
          v-if="datePickerVisible"
          v-model="formData.dateVal"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          :default-time="defaultTime"
          popper-class="open-clock-schedule-picker"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="hide">取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
        :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { settingAdScheduleOpenTask } from '../../serve/setTimes';
import moment from 'moment';
// import { settingAdScheduleOpenTaskMobile } from '@/api/multiPlatform.js';
export default {
  props: {
    selectedRowScopes: {
      type: Array,
      default: () => [],
    },
    level: {
      type: String,
      default: 'campaign',
    },
    platform: String,
    type: {
      type: Number | String,
      default: 1,
    },
    gimpUserId: {
      type: [String, Number],
    },
    defaultDataOpenClock: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        dateVal: '',
        // taskType: '',
      },
      // 设置不能选则当天之前的时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      loading: false,
      defaultTime: '00:00:00',
      datePickerVisible: true,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  methods: {
    show() {
      this.datePickerVisible = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.defaultTime = this.type == 1 ? '00:00:00' : '23:50:00';
        // 编辑的时候默认填充时间
        if (this.defaultDataOpenClock?.timeStr) {
          this.formData.dateVal = this.defaultDataOpenClock.timeStr;
        } else {
          // 设置默认日期时间
          if (this.type == 1) {
            // type=1时，默认次日的00:00:00
            this.formData.dateVal = moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          } else {
            // 否则默认当天的23:50:00
            this.formData.dateVal = moment().hour(23).minute(50).second(0).format('YYYY-MM-DD HH:mm:ss');
          }
        }

        this.datePickerVisible = true;
      });
    },
    hide() {
      this.formData.dateVal = '';
      this.dialogVisible = false;
    },
    submit() {
      if (!this.formData.dateVal) {
        return this.$message.warning('请选择开启日期');
      }
      let request = {
        // adAccountId: this.$store.getters.accountId,
        level: this.level,
        handleTime: this.formData.dateVal,
        // taskType: this.formData.taskType,
        // ids: this.setTimeIds,
        scheduleType: this.type,
      };
      this.loading = true;
      console.log(this.selectedRowScopes);
      let arr = this.selectedRowScopes.map((v) => {
        return {
          id: v.id,
          level: this.level,
          platform: this.platform,
          adAccountId: v.rowAccountId,
          thirdUserId: v.rowThirdNum,
          campaignId: v.campaign_id,
          adGroupId: v.adset_id,
          adGroupAdId: this.level == 'ad' ? v.id : null,
        };
      });
      let obj = { ...request, gimpUserId: this.gimpUserId || this.userInfo.data.id, adInfos: [...arr] };
      settingAdScheduleOpenTask(JSON.stringify(obj))
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(`定时${this.type == 1 ? '开启' : '关闭'}已打开！`);
            res.data.forEach((item) => {
              this.$emit('settingComplete', this.formData, item.type, item.adId, null, item.id, res.data);
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 100%;
}
</style>

<style lang="scss">
/* modal=false：不生成 body 级 .v-modal，遮罩画在 wrapper 上，避免盖住弹窗 */
.el-dialog__wrapper:has(.open-clock-schedule-dialog) {
  z-index: 5000 !important;
  background-color: rgba(0, 0, 0, 0.5);
}
/* 日期面板默认挂 body，z-index 约 2000，必须高于 wrapper 遮罩 */
.open-clock-schedule-picker {
  z-index: 5001 !important;
}
</style>
